import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _excluded = ["onClickGetStarted"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import Image from 'next/legacy/image';
import { useTranslation, Trans } from '@yoweb/next-i18next';
import { th } from '@yoweb/ui/styles/utils/theme';
import { gridBase, media, pxToRem } from '@yoweb/ui/styles/utils';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons';
import { Title } from '@yoweb/ui/components/typography';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import HeroImageDesktopEn from '@store/public/images/pricing/price-hero-desktop.png';
import HeroImageTabletEn from '@store/public/images/pricing/price-hero-tablet.png';
import HeroImageMobileEn from '@store/public/images/pricing/price-hero-mobile.png';
import HeroImageDesktopJa from '@store/public/images/pricing/price-hero-desktop-ja.jpeg';
import HeroImageTabletJa from '@store/public/images/pricing/price-hero-tablet-ja.jpeg';
import HeroImageMobileJa from '@store/public/images/pricing/price-hero-mobile-ja.jpeg';
import { Disclaimer } from './Disclaimer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeroSection = function HeroSection(props) {
  var _useTranslation = useTranslation('pricing'),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapan = lcLocale === 'ja-jp';

  var onClickGetStarted = props.onClickGetStarted,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx(Box, {
    "data-testid": "pricing-section-hero",
    mt: "xl3",
    children: /*#__PURE__*/_jsxs(BoxContainerGrid, {
      mx: "auto",
      children: [/*#__PURE__*/_jsxs(HeroTextBox, {
        pt: {
          _: 0,
          lg: 'large1'
        },
        px: {
          _: 'normal2',
          md: 'medium1',
          lg: 'small3'
        },
        children: [/*#__PURE__*/_jsx(Title, {
          size: {
            _: 'md',
            md: 'lg',
            lg: 'xl'
          },
          textAlign: {
            _: 'center',
            lg: 'left'
          },
          whiteSpace: "pre-line",
          children: t('hero-section.title')
        }), /*#__PURE__*/_jsx(Box, {
          mt: "normal3",
          children: /*#__PURE__*/_jsx(Title, {
            size: {
              _: 'xs',
              lg: 'sm'
            },
            weight: "regular",
            variant: "muted",
            textAlign: {
              _: 'center',
              lg: 'left'
            },
            children: t('hero-section.description')
          })
        }), /*#__PURE__*/_jsx(PriceHeader, _objectSpread({}, rest)), /*#__PURE__*/_jsx(Box, {
          mt: "normal2",
          display: "flex",
          justifyContent: {
            _: 'center',
            lg: 'start'
          },
          children: /*#__PURE__*/_jsx(Button, {
            size: "lg",
            "data-testid": "pricing-hero-get-started-btn",
            onClick: onClickGetStarted,
            type: "button",
            children: t('hero-section.cta-text')
          })
        }), /*#__PURE__*/_jsx(Box, {
          mt: {
            _: 'normal3',
            lg: 'normal4'
          },
          children: /*#__PURE__*/_jsx(Disclaimer, _objectSpread({}, rest))
        })]
      }), /*#__PURE__*/_jsx(HeroImageArea, {
        display: {
          _: 'block',
          md: 'none'
        },
        children: /*#__PURE__*/_jsx(Image, {
          src: isJapan ? HeroImageMobileJa : HeroImageMobileEn,
          objectFit: "cover",
          layout: "fill"
        })
      }), /*#__PURE__*/_jsx(HeroImageArea, {
        display: {
          _: 'none',
          md: 'block',
          lg: 'none'
        },
        children: /*#__PURE__*/_jsx(Image, {
          src: isJapan ? HeroImageTabletJa : HeroImageTabletEn,
          objectFit: "cover",
          layout: "fill"
        })
      }), /*#__PURE__*/_jsx(HeroImageArea, {
        display: {
          _: 'none',
          lg: 'block'
        },
        children: /*#__PURE__*/_jsx(Image, {
          src: isJapan ? HeroImageDesktopJa : HeroImageDesktopEn,
          objectFit: "cover",
          layout: "fill"
        })
      })]
    })
  });
};
export var PriceHeader = function PriceHeader(props) {
  var _useTranslation2 = useTranslation('pricing'),
      t = _useTranslation2.t;

  var basePrice = props.basePrice,
      hasCoupon = props.hasCoupon,
      useSubscriptionTrialRepeatingUi = props.useSubscriptionTrialRepeatingUi,
      useSubscriptionTrialOnceUi = props.useSubscriptionTrialOnceUi,
      discountPrice = props.discountPrice,
      discountMonths = props.discountMonths,
      initialOfferMonths = props.initialOfferMonths,
      initialOfferDays = props.initialOfferDays,
      initialOfferPrice = props.initialOfferPrice,
      initialOfferPriceFormatted = props.initialOfferPriceFormatted;

  if (useSubscriptionTrialRepeatingUi) {
    return /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      mt: "normal3",
      flexDirection: {
        _: 'column',
        lg: 'row'
      },
      alignItems: "center",
      flexWrap: {
        _: 'wrap'
      },
      justifyContent: {
        _: 'center',
        lg: 'start'
      },
      children: [/*#__PURE__*/_jsx(Title, {
        size: "xs",
        weight: "bold",
        children: // Special case if the initial offer period is free - copy should say "free" instead of money amount.
        initialOfferPrice === 0 ? /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "common.price-line-1-combo-free",
          values: {
            count: initialOfferMonths
          }
        }) : /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "common.price-line-1-combo",
          values: {
            count: initialOfferMonths,
            initialOfferPrice: initialOfferPriceFormatted
          }
        })
      }), /*#__PURE__*/_jsx(Box, {
        display: {
          _: 'none',
          lg: 'inline'
        },
        children: "\xA0"
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "hero-section.discount.price-line-2-combo",
          components: [/*#__PURE__*/_jsx(Title, {
            as: "span",
            size: "xs",
            weight: "regular",
            variant: "muted3"
          }, 0), /*#__PURE__*/_jsx(TitleStrikeMargins, {
            as: "span",
            size: "xs",
            weight: "regular"
          }, 1), /*#__PURE__*/_jsx(Title, {
            as: "span",
            size: "xs",
            weight: "regular",
            variant: "muted3"
          }, 2)],
          values: {
            count: discountMonths,
            basePrice: basePrice,
            discountPrice: discountPrice
          }
        })
      })]
    });
  } else if (useSubscriptionTrialOnceUi) {
    var priceLine2Key = 'hero-section.discount.price-line-2-months';
    var count = initialOfferMonths;

    if (initialOfferDays && initialOfferDays > 0) {
      priceLine2Key = 'hero-section.discount.price-line-2-days';
      count = initialOfferDays;
    }

    return /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      mt: "normal3",
      justifyContent: {
        _: 'start'
      },
      flexWrap: {
        _: 'wrap'
      },
      flexDirection: {
        _: 'column',
        lg: 'row'
      },
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: /*#__PURE__*/_jsx(Title, {
          size: "sm",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: "common.price-line-subscription-trial",
            values: {
              initialOfferPrice: initialOfferPriceFormatted
            }
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: [/*#__PURE__*/_jsx(Box, {
          display: {
            _: 'none',
            lg: 'inline'
          },
          children: "\xA0"
        }), /*#__PURE__*/_jsx(Title, {
          as: "span",
          size: "xs",
          weight: "regular",
          variant: "muted",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: priceLine2Key,
            values: {
              count: count
            }
          })
        })]
      })]
    });
  } else if (hasCoupon) {
    return /*#__PURE__*/_jsxs(Box, {
      display: "flex",
      mt: "normal3",
      justifyContent: {
        _: 'start'
      },
      flexWrap: {
        _: 'wrap'
      },
      flexDirection: {
        _: 'column',
        lg: 'row'
      },
      children: [/*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: /*#__PURE__*/_jsx(Trans, {
          t: t,
          i18nKey: "hero-section.discount.price-line",
          components: [/*#__PURE__*/_jsx(TitleStrike, {
            size: "sm",
            weight: "regular",
            variant: "muted2"
          }, 0), /*#__PURE__*/_jsx(TitleMargin, {
            size: "sm"
          }, 1), /*#__PURE__*/_jsx(Title, {
            size: "xs",
            weight: "regular",
            variant: "muted"
          }, 2)],
          values: {
            basePrice: basePrice,
            discountPrice: discountPrice
          }
        })
      }), /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: {
          _: 'center',
          lg: 'start'
        },
        children: [/*#__PURE__*/_jsx(Box, {
          display: {
            _: 'none',
            lg: 'inline'
          },
          children: "\xA0"
        }), /*#__PURE__*/_jsx(Title, {
          as: "span",
          size: "xs",
          weight: "regular",
          variant: "muted",
          children: /*#__PURE__*/_jsx(Trans, {
            t: t,
            i18nKey: "hero-section.discount.price-line-2-months",
            values: {
              count: discountMonths
            }
          })
        })]
      })]
    });
  }

  return /*#__PURE__*/_jsx(Box, {
    display: "flex",
    mt: "normal3",
    flexDirection: {
      _: 'column',
      lg: 'row'
    },
    children: /*#__PURE__*/_jsx(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: {
        _: 'center',
        lg: 'start'
      },
      children: /*#__PURE__*/_jsx(Trans, {
        t: t,
        i18nKey: "common.price-line",
        components: [/*#__PURE__*/_jsx(TitleMargin, {
          size: "sm"
        }, 0), /*#__PURE__*/_jsx(Title, {
          size: "xs",
          weight: "regular",
          variant: "muted"
        }, 1)],
        values: {
          basePrice: basePrice
        }
      })
    })
  });
}; // Hero section component styles

var BoxContainerGrid = styled(Box).withConfig({
  componentId: "sc-fmowpw-0"
})(["&&{max-width:", ";", ";}"], th.getSize('containerWidth'), gridBase);
var HeroTextBox = styled(Box).withConfig({
  componentId: "sc-fmowpw-1"
})(["&&{grid-column:1/5;", " ", "}"], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-column: 2/8;\n  "]))), media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    grid-column: 1/6;\n  "]))));
var HeroImageArea = styled(Box).withConfig({
  componentId: "sc-fmowpw-2"
})(["&&{grid-column:1/-1;height:", ";margin:", " 0;overflow:hidden;position:relative;", " ", "}"], pxToRem(480), th.getSpace('normal2'), media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin: ", " 0;\n  "])), th.getSpace('normal3')), media.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    grid-column: 6/-1;\n    height: ", ";\n    margin: 0 ", ";\n  "])), th.getRadii('large'), pxToRem(664), th.getSpace('small3')));
var TitleMargin = styled(Title).withConfig({
  componentId: "sc-fmowpw-3"
})(["&&{margin-left:", ";}"], th.getSpace('normal1'));
var TitleStrike = styled(Title).withConfig({
  componentId: "sc-fmowpw-4"
})(["&&{text-decoration:", " line-through;}"], th.getColor('critical'));
var TitleStrikeMargins = styled(Title).withConfig({
  componentId: "sc-fmowpw-5"
})(["&&{text-decoration:", " line-through;margin-left:", ";margin-right:", ";color:", ";}"], th.getColor('critical'), th.getSpace('small1'), th.getSpace('small3'), th.getColor('base200'));